import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { runInAction } from "mobx";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreUIStore from "../../stores/core/core-ui-store";

const MobileNavToggle = withLiteObserverAndTheme(() => {
  const { isMobileNavOpen } = getCoreUIStore();

  return (
    <IconButton
      aria-label={i18n.get("MAIN_NAVIGATION")}
      onClick={() => runInAction(() => isMobileNavOpen.set(true))}
    >
      <MenuIcon />
    </IconButton>
  );
});
export default MobileNavToggle;
